module.exports = __webpack_public_path__ + "img/SofiaConfecciones.8c325cb1.png";